/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './update-team-member';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "team_api": {
        "nested": {
          "BulkUpdateTeamMembersRequest": {
            "fields": {
              "teamMembers": {
                "type": ".squareup.team_api.UpdateTeamMemberRequest",
                "id": 1,
                "keyType": "string"
              }
            }
          },
          "BulkUpdateTeamMembersResponse": {
            "fields": {
              "teamMembers": {
                "type": ".squareup.team_api.UpdateTeamMemberResponse",
                "id": 1,
                "keyType": "string"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.team_api?.nested?.BulkUpdateTeamMembersRequest && !$root.nested?.squareup?.nested?.team_api?.nested?.BulkUpdateTeamMembersResponse) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents a bulk update request for `TeamMember` objects.
 * --
 *
 * SOURCE BulkUpdateTeamMembersRequest @ squareup/team_api/endpoints/bulk-update-team-members.proto at 23:1
 */
export const BulkUpdateTeamMembersRequest = $root.lookupType('squareup.team_api.BulkUpdateTeamMembersRequest');
fixType(BulkUpdateTeamMembersRequest, {
  teamMembers: {
    required: true
  }
});
Builder.createAndAttachToType(BulkUpdateTeamMembersRequest);
/**
 * --
 * @desc Represents a response from a bulk update request containing the updated `TeamMember` objects or error messages.
 * --
 *
 * SOURCE BulkUpdateTeamMembersResponse @ squareup/team_api/endpoints/bulk-update-team-members.proto at 42:1
 */
export const BulkUpdateTeamMembersResponse = $root.lookupType('squareup.team_api.BulkUpdateTeamMembersResponse');
fixType(BulkUpdateTeamMembersResponse);
Builder.createAndAttachToType(BulkUpdateTeamMembersResponse);